export default function Hero() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fashion%20product%20collage%20featuring%20sneakers%20hoodies%20bags%20accessories%20and%20clothing%20items%20artistically%20arranged%20on%20light%20sand%20textured%20surface%20with%20modern%20studio%20lighting%2C%20minimalist%20editorial%20aesthetic%2C%20diverse%20warm%20neutral%20color%20palette%20with%20visual%20depth%2C%20harmonious%20organic%20composition%20with%20gentle%20directional%20shadows&width=1600&height=1000&seq=hero-bg-v2-banner&orientation=landscape"
          alt="OOPBuy Spreadsheet fashion products collage"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-background-50/95"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row items-center gap-12 md:gap-16 max-w-[1280px] mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <p className="text-xs md:text-sm font-medium text-background-50/90 tracking-widest uppercase mb-4">
              2026 Updated Guide
            </p>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
              OOPBuy Spreadsheet
              <br />
              <span className="italic font-normal text-background-50/80">
                The Smartest Way to Shop
              </span>
            </h1>
            <p className="text-background-50/85 text-base md:text-lg max-w-lg mx-auto lg:mx-0 mb-8 leading-relaxed">
              A powerful spreadsheet-based shopping system that helps users compare products, track orders, and save time with a simplified digital workflow.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                Explore OOPBuy Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 border border-background-50/50 text-background-50 font-medium text-sm rounded-md hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                Visit Official Platform
              </a>
            </div>
          </div>

          <div className="flex-1 hidden lg:block">
            <div className="relative rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20of%20modern%20fashion%20items%20including%20leather%20shoes%20folded%20clothing%20and%20minimalist%20accessories%20on%20light%20travertine%20stone%20surface%20with%20warm%20directional%20lighting%2C%20luxury%20editorial%20product%20photography%2C%20diverse%20neutral%20tones%2C%20designer%20magazine%20style%20composition%20with%20intentional%20negative%20space&width=800&height=600&seq=hero-right-v2-side&orientation=landscape"
                alt="OOPBuy Spreadsheet shopping guide"
                className="w-full h-auto rounded-3xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}